import TransactionDetailsModal from './TransactionDetailsModal'

export default TransactionDetailsModal
